// extracted by mini-css-extract-plugin
module.exports = {"uspContainer":"USP-module__uspContainer"};